module.exports = {
    pf: {
        title: "O que você quer fazer na Thank You Me?",
        options: [
            {
                title: "Quero me cadastrar para fazer doações e criar um perfil de doador no site",
                value: "PF_QUERO_PERFIL_DE_DOADOR",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true
                },
                nextRoute: 'etapa_5'
            },
            {
                title: "Quero apenas realizar uma doação sem criar um perfil de doador no site",
                value: "PF_NAO_QUERO_PERFIL_DE_DOADOR",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: true
                },
                nextRoute: 'etapa_4'
            }
        ]
    },
    pf_register: {
        title: "Você já tem um registro na nossa plataforma. O que deseja fazer agora?",
        options: [
            {
                title: "Quero realizar uma nova doação",
                value: "PF_QUERO_PERFIL_DE_DOADOR",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true
                },
                nextRoute: 'etapa_4'
            },
            // {
            //     title: "Quero editar meu cadastro",
            //     value: "PF_QUERO_EDITAR_CADASTRO",
            //     selected: false,
            //     config: {
            //         cadastro: true,
            //         criar_perfil: false,
            //         fazer_doacao: true
            //     },
            //     nextRoute: 'fale-conosco',
            //     isOutRoute: true
            // }
        ]
    },
    ong: {
        title: "O que você quer fazer na Thank You Me?",
        options: [
            {
                title: "Quero me cadastrar para receber ou doar e criar um perfil de ONG no site",
                value: "ONG_QUERO_CADASTRAR_COM_PERFIL_PARA_DOAR_OU_RECEBER",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true,
                    receber_doacao: true
                },
                nextRoute: 'etapa_5',
            },
            {
                title: "Quero apenas realizar uma doação sem criar um perfil de ONG no site",
                value: "ONG_QUERO_CADASTRAR_SEM_PERFIL_PARA_DOAR",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: true,
                    receber_doacao: false
                },
                  nextRoute: 'etapa_4',
            },
            {
                title: "Minha ONG precisa de algo que está sendo doado",
                value: "ONG_QUERO_CADASTRAR_SEM_PERFIL_PARA_RECEBER_DOACAO",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: false,
                    receber_doacao: true
                },
                nextRoute: 'etapa_4_1',
            }
        ]
    },
    ong_register: {
        title: "O que você quer fazer na Thank You Me?",
        options: [
            {
                title: "Quero me cadastrar para receber ou doar e criar um perfil de ONG no site",
                value: "ONG_QUERO_CADASTRAR_COM_PERFIL_PARA_DOAR_OU_RECEBER",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true,
                    receber_doacao: true
                },
                nextRoute: 'etapa_5',
            },
            {
                title: "Quero apenas realizar uma doação sem criar um perfil de ONG no site",
                value: "ONG_QUERO_CADASTRAR_SEM_PERFIL_PARA_DOAR",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: true,
                    receber_doacao: false
                },
                  nextRoute: 'etapa_4',
            },
            {
                title: "Minha ONG precisa de algo que está sendo doado",
                value: "ONG_QUERO_CADASTRAR_SEM_PERFIL_PARA_RECEBER_DOACAO",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: false,
                    receber_doacao: true
                },
                nextRoute: 'etapa_4_1',
            }
        ]
    },
    pj: {
        title: "O que você quer fazer na Thank You Me?",
        options: [
            {
                title: "Quero me cadastrar para fazer doações e criar um perfil de doador no site",
                value: "PJ_QUERO_CADASTRAR_COM_PERFIL_PARA_DOAR",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true,
                    receber_doacao: false
                },
                nextRoute: 'etapa_5'
            },
            {
                title: "Quero apenas realizar uma doação sem criar um perfil de doador no site",
                value: "PJ_QUERO_CADASTRAR_SEM_PERFIL_PARA_DOAR",
                selected: false,
                config: {
                    cadastro: true,
                    criar_perfil: false,
                    fazer_doacao: true,
                    receber_doacao: false
                },
                nextRoute: 'etapa_4'
            }
        ]
    },
    pj_register: {
        title: "Você já tem um registro na nossa plataforma. O que deseja fazer agora?",
        options: [
            {
                title: "Quero realizar uma nova doação",
                value: "PJ_QUERO_PERFIL_DE_DOADOR",
                selected: true,
                config: {
                    cadastro: true,
                    criar_perfil: true,
                    fazer_doacao: true
                },
                nextRoute: 'etapa_4'
            },
            // {
            //     title: "Quero editar meu cadastro",
            //     value: "PJ_QUERO_EDITAR_CADASTRO",
            //     selected: false,
            //     config: {
            //         cadastro: true,
            //         criar_perfil: false,
            //         fazer_doacao: true
            //     },
            //     nextRoute: 'fale-conosco',
            //     isOutRoute: true
            // }
        ]
    }


}
